<template>
    <v-row>
        <v-col>
            <view-card headline="고객" :disabled="!isConsole">
                <v-row>
                    <v-col class="pt-0">
                        <v-text-field v-model="value.employer.name" label="성명" placeholder=" " hide-details />
                    </v-col>
                    <v-col class="pt-0">
                        <v-text-field v-model="value.employer.phone" label="연락처" placeholder=" " hide-details />
                    </v-col>
                </v-row>
                <v-text-field v-model="value.employer.address" label="시공지주소" placeholder=" " hide-details />
            </view-card>
        </v-col>
        <v-col>
            <view-card headline="담당자" :disabled="!isConsole">
                <v-row>
                    <v-col cols="6" class="pt-0">
                        <v-select
                            v-model="value.measurer._user"
                            :items="measurers"
                            item-value="_id"
                            :item-text="({ name, phone }) => `${name} / ${phone.phoneNumberFormat()}`"
                            label="직원명"
                            placeholder=" "
                            hide-details
                        />
                    </v-col>
                </v-row>
                <v-text-field v-model="value.measurer.consultationLocation" label="상담장소" placeholder=" " hide-details />
            </view-card>
        </v-col>
    </v-row>
</template>
<script>
import viewCard from "../dumb/view-card.vue";
export default {
    components: { viewCard },
    props: {
        value: {
            employer: {
                name: { type: String, default: null },
                phone: { type: String, default: null },
                address: { type: String, default: null },
            },

            measurer: {
                _user: { type: String, default: null },
                consultationLocation: { type: String, default: null },
            },
        },
        measurers: { type: Array, default: [] },
    },
    computed: {
        isConsole() {
            return this.$store.state.payload.scope.includes("console");
        },
    },
};
</script>
